module.exports = __webpack_public_path__ + "img/person_inner_step3.1b90ef3a.png";